<template>
  <v-ons-page class="l-content l-contact">
    <div class="container">
      <div v-for="(region, index) in regions" :key="index" class="infoContent">
        <h2>{{ $t(region.name) }}</h2>
        <div class="info">
          <i class="fas fa-map-marker-alt"></i>
          <div class="infoName">
            <span v-html="region.address"></span>
            <br>
            {{ region.zip }} {{ region.city }}
          </div>
        </div>
        <div class="info">
          <i class="fas fa-phone"></i>
          <div class="infoName">
            <a :href="'tel:' + region.tel">{{ region.tel }}</a>
          </div>
        </div>
        <div class="info">
          <i class="fas fa-envelope"></i>
          <div class="infoName">{{ region.email }}</div>
        </div>
      </div>
    </div>
  </v-ons-page>
</template>

<script>
  export default {
    data () {
      return {
        regions: regions_contacts
      };
    },
  };
</script>


// WEBPACK FOOTER //
// Contact.vue?07f1b05a